// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ReplyAllIconSignature {
  Element: SVGSVGElement;
}

export const ReplyAllIcon: TOC<ReplyAllIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.707 6L10.121 7.50202L7.0605 11L10.121 14.498L8.707 16L4 11L8.707 6ZM12.414 10H15C18.309 10 21 12.691 21 16V18H19V16C19 13.794 17.205 12 15 12H12.414L14.707 14.293L13.293 15.707L8.586 11L13.293 6.293L14.707 7.707L12.414 10Z"/>
</svg>
</template>;